/* * @Author: suzilong * @Date: 2018-10-16 13:57:43 * @Last Modified by: suzilong * @Last Modified time: 2020-09-01 13:40:07
* @Description: 安全控件显示及属性设置封装 * @Copyright (c) 2018 CFCA [http://www.cfca.com.cn] All rights reserved. */
<template>
  <input class="login-form-field a4" :id="id" :name="id" :placeholder="placeholder" oncopy="return false;" onpaste="return false;"
    oncut="return false;" />
  <!-- 1.子div的高度必须比父div大17px,主要是为了遮挡住scrollbar 2.子div宽度与父div宽度保持一致-->
</template>
<script>
  /* eslint-disable no-undef */
  export const KEYBOARD_TYPE = {
    SIP_TYPE_SYSTEM_KEYBOARD: 0,
    SIP_TYPE_SOFT_KEYBOARD: 1,
    SIP_TYPE_SOFT_ADN_SYSTEM_KEYBOARD: 2,
  };
  export const OUTPUTTYPE = {
    OUTPUT_TYPE_ORIGINAL: 1,
    OUTPUT_TYPE_HASH: 2,
  };
  export const CIPHERTYPE = {
    CIPHER_TYPE_SM2: 0,
    CIPHER_TYPE_RSA: 1,
  };
  export const SERVERRANDOM_CIPHERTYPE = {
    SERVERRANDOM_CIPHER_TYPE_SM4: 0,
    SERVERRANDOM_CIPHER_TYPE_3DES: 1,
  };
  export const PUBLICKEYTOENCRYPT = {
    PUBLIC_KEY_OPEN_PLATFORM: 0,
    PUBLIC_KEY_EBANK: 1,
  };
  export const RANDOMTYPE = {
    RANDOM_NONE: 0,
    RANDOM_DIGITAL: 1,
    RANDOM_ALL: 2,
  };
  export const CFCA_OK = '0';
  export default {
    props: {
      keyboardType: KEYBOARD_TYPE,
      id: String,
      attr: Object,
      placeholder: String,
    },
    data() {
      return {
        publicPath: process.env.BASE_URL,
        jskeyboard: null,
        jskeyboard1: null,
        errorCode: 0,
      };
    },
    name: 'SipEdit',

    created() {
      if (document.getElementById('baseMinScript')) {
        return;
      }
      const BaseScript = document.createElement('script');
      BaseScript.setAttribute('id', 'baseMinScript');
      BaseScript.src = `${this.publicPath}/CFCASIPInput.min.js`;
      BaseScript.onload = this.onLoadKeyboard;
      document.getElementsByTagName('head')[0].appendChild(BaseScript);
    },

    destroyed() {
      const BaseScript = document.getElementById('baseMinScript');
      if (BaseScript) {
        BaseScript.remove();
      }
    },
    watch: {
      attr: {
        handler(curVal) {
          if (this.jskeyboard) {
            this.setAttrs(curVal);
          }
          if (this.jskeyboard1) {
            this.setAttrs(curVal);
          }
        },
        deep: true,
      },
      errorCode(code) {
        if (code !== CFCA_OK) {
          this.$emit('onError', code);
        }
      },
    },
    methods: {
      onLoadKeyboard() {
        this.$emit('onJsLoad');
      },

      initKeyboard() {
        if (!this.jskeyboard) {
          this.jskeyboard = new CFCASIPInput(this.id);
        }
        this.setAttrs(this.attr);
      },

      initKeyboard1() {
        if (!this.jskeyboard1) {
          this.jskeyboard1 = new CFCASIPInput(this.id);
        }
        this.setAttrs(this.attr);
      },

      setAttrs(attrs) {
        if (this.jskeyboard) {
          this.errorCode = this.jskeyboard.setCipherType(attrs.cipherType);
          this.errorCode = this.jskeyboard.setMinLength(attrs.minLength);
          this.errorCode = this.jskeyboard.setMaxLength(attrs.maxLength);
          this.errorCode = this.jskeyboard.setOutputType(attrs.outputType);
          this.errorCode = this.jskeyboard.setServerRandomCipherType(attrs.serverRandomCipherType);
          this.errorCode = this.jskeyboard.setPublicKeyToEncrypt(attrs.publicKeyToEncrypt)
        }

        if (this.jskeyboard1) {
          this.errorCode = this.jskeyboard1.setCipherType(attrs.cipherType);
          this.errorCode = this.jskeyboard1.setMinLength(6);
          this.errorCode = this.jskeyboard1.setMaxLength(6);
          this.errorCode = this.jskeyboard1.setOutputType("1");
          this.errorCode = this.jskeyboard1.setServerRandomCipherType(attrs.serverRandomCipherType);
          this.errorCode = this.jskeyboard1.setPublicKeyToEncrypt(attrs.publicKeyToEncrypt)
        }

      },

      showKeyboard() {
        if (!this.jskeyboard) {
          this.onLoadKeyboard();
        }
        if (this.keyboardType === KEYBOARD_TYPE.SIP_TYPE_SYSTEM_KEYBOARD) {
          return;
        }
        if (this.jskeyboard) {
          this.jskeyboard.showKeyboard(this.id, this.attr.randomType);
        }
      },

      hideKeyboard() {
        if (this.jskeyboard) {
          this.jskeyboard.hideKeyboard(this.id);
        }
      },

      getCipherAttributes() {
        if (this.jskeyboard) {
          return this.jskeyboard.getCipherAttributes(this.id);
        }
        return '';
      },

      setServerRandom(serverRandom) {
        if (this.jskeyboard) {
          this.jskeyboard.setServerRandom(serverRandom);
        }
      },

      setServerRandom1(serverRandom) {
        if (this.jskeyboard1) {
          this.jskeyboard1.setServerRandom(serverRandom);
        }
      },

      getEncryptedInputValue() {
        if (this.jskeyboard) {
          const encryptData = this.jskeyboard.getEncryptedInputValue(this.id);
          this.checkError();
          return encryptData;
        }
        return '';
      },

      getEncryptedClientRandom() {
        if (this.jskeyboard) {
          const encryptedRandom = this.jskeyboard.getEncryptedClientRandom(this.id);
          this.checkError();
          return encryptedRandom;
        }
        return '';
      },

      getEncryptedInputValue1() {
        if (this.jskeyboard1) {
          const encryptData = this.jskeyboard1.getEncryptedInputValue(this.id);
          return encryptData;
        }
        return '';
      },

      getEncryptedClientRandom1() {
        if (this.jskeyboard1) {
          const encryptedRandom = this.jskeyboard1.getEncryptedClientRandom(this.id);
          return encryptedRandom;
        }
        return '';
      },

      getVersion() {
        if (this.jskeyboard) {
          return getCFCASIPInputVersion();
        }
        return '';
      },

      checkError() {
        if (this.jskeyboard) {
          const errorCode = this.jskeyboard.getErrorCode(this.id).toString(16);
          if (errorCode !== CFCA_OK) {
            this.$emit('onError', errorCode);
          }
        }
      },

      clear() {
        if (this.jskeyboard) {
          this.jskeyboard.clearInputValue(this.id);
        }
      },
      checkEqual(otherId) {
        if (this.jskeyboard) {
          const equal = this.jskeyboard.checkInputValueMatch(this.id, otherId);
          return equal;
        }
        return false;
      },
    },
  };
</script>


<style lang="less" scoped>
  @media screen and (max-width: 640px) {
    @import "../styles/mobile/m_login.less";
  }

  @media screen and (min-width: 641px) {
    @import "../styles/pc/login.less";
  }

  div {
    padding-bottom: 10px;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/SipEdit.vue